import "../style/footer.css"


export default function Footer(){


    return (
        <div className="footer ">
            <div className="footerLeftColumn">
                <div className="footerColumnTitle ">Links & Meta</div>
                <div className="flex flex-column justify-between ">
                   <div className=" ">
                        <div className="font-bold ">Universitätsklinikum Freiburg</div>
                        <div className="flex flex-col mt-3">
                            <a href="https://www.uniklinik-freiburg.de/de.html">Zum Universitätsklinikum Freiburg</a>
                            <a href="https://www.uniklinik-freiburg.de/musikermedizin.html">Zum Freiburger Institut für Musikermedizin</a>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="font-bold ">Meta</div>
                        <div className="flex flex-col mt-3">
                            <a href="/">Login</a>
                            <a href="https://www.uniklinik-freiburg.de/footernavigation/impressum.html" target="_blank">Impressum</a>
                            <a href="https://www.uniklinik-freiburg.de/footernavigation/datenschutz.html" target="_blank">Datenschutz</a>
                        </div>
                    </div>  
                </div>
                
            </div>
            
            <div className="footerMiddleColumn ">
                <a href="https://www.uniklinik-freiburg.de/musikermedizin.html">
                    <img src="https://lehgu.de/prof_cms/fileadmin/lehgu/media/fim_logo.1e499485.png" alt="fim_logo.1e499485.png" 
                    title="" className="img-fluid " id="img-2013-0" loading="auto" 
                    width="200px"
                    />
                </a>
                <a href="https://www.uniklinik-freiburg.de/de.html">
                    <img src="https://lehgu.de/prof_cms/fileadmin/lehgu/media/ukf.svg" alt="fim_logo.1e499485.png" 
                    title="" className="img-fluid " id="img-2013-0" loading="auto" 
                    width="150px"
                    />
                </a>
            </div>

            <div className="footerRightColumn ">
                <div className="footerColumnTitle ">Kontakt</div>
                <div className="font-bold  ">Freiburger Institut für Musikermedizin (FIM)</div>
                <div className="mt-3">
                    <div className=" ">Universitätsklinikum Freiburg</div>
                    <div className=" ">Elsässer Straße 4 d</div>
                    <div className=" ">79110 Freiburg</div>
                </div>
                <div className="mt-3">
                    <div className=" ">Telefon: 0761 270-61610 (Sekretariat-Institut)</div>
                    <div className=" ">
                        <a href="/#">info@lehgu.de</a>
                    </div>
                </div>

            </div>
        </div>
    )
}